<template>
	<Col class="width-100 height-100 flex-centerize pb-12">
		<Col class="content-container">
			<h1 class="bold text-center mb-6">Workspace change is required</h1>
			<Row class="width-100 flex-centerize">
				<h3 class="reg">You're trying to access resources from the workspace&nbsp;</h3>
				<AppWorkspaceAvatar :account="requiredAccount" />.
			</Row>
			<Row class="danger-area pa-3 my-4 width-100"> {{ dangerText }} </Row>
			<Row class="width-100 flex-centerize">
				<AnemicButton tile class="cancel-button mr-5" @click="goToPlacementAddOns"> Cancel </AnemicButton>
				<AnemicButton tile class="yes-button" :loading="isLoading" @click="switchAccounts"> Change active workspace </AnemicButton>
			</Row>
		</Col>
	</Col>
</template>

<script>
import { CREATE_AND_MANAGE_ROUTE_NAME } from '@/router/router.const.js';
import AppWorkspaceAvatar from '@/components/WorkspaceSelectionMenu/AppWorkspaceAvatar.vue';
import WorkspaceSelectionMenuMixin from '@/components/WorkspaceSelectionMenu/mixins/WorkspaceSelectionMenuMixin.js';
const DANGER_TEXT =
	'Switching workspace will change the data you see in Ply. It will affect all the tabs you have open, and the Ply extension buttons you see on other websites.';
export default {
	mixins: [WorkspaceSelectionMenuMixin],
	name: 'AccountChangeRequired',
	components: { AppWorkspaceAvatar },
	props: {
		redirect: { type: Function },
		accountId: { type: Number, required: true },
	},
	computed: {
		requiredAccount() {
			return this.useAccount(this.accountId);
		},
	},
	methods: {
		async switchAccounts() {
			this.isLoading = true;
			await this.changeWorkspace(this.accountId);
			this.isLoading = false;
			if (this.redirect) {
				this.redirect();
			} else {
				this.goToPlacementAddOns();
			}
		},
		goToPlacementAddOns() {
			this.$router.push({ name: CREATE_AND_MANAGE_ROUTE_NAME });
		},
	},
	data: () => ({
		isLoading: false,
		dangerText: DANGER_TEXT,
	}),
	mounted() {
		if (!this.redirect) {
			this.goToPlacementAddOns();
		}
	},
};
</script>

<style scoped lang="scss">
.content-container {
	max-width: 500px;
}
.danger-area {
	font-size: 14px;
	border-radius: 5px;
	background: #d4e6ff;
	border: 1px solid #e2e7f0;
	color: var(--primary-font-color);
}
.footer-button {
	height: 40px !important;
	font-size: 14px !important;
	min-width: 230px !important;
	border-radius: 8px !important;
	letter-spacing: 0px !important;
	color: var(--white) !important;
	font-weight: normal !important;
	text-transform: none !important;
}

.yes-button {
	@extend .footer-button;
	color: var(--white) !important;
	background: var(--bold-border-color) !important;
}

.cancel-button {
	@extend .footer-button;
	border: 1px solid #d6ddea;
	background: var(--white) !important;
	color: var(--primary-font-color) !important;
}
</style>
